export default {
    laufid_customers: "Brot af okkar viðskiptavinum",

    register_your_company: "Skráðu fyrirtækið þitt í fría prufuáskrift!",

    faq: "FAQ",
    try_free: "Bókaðu prufu",
    stories: "Sögur",
    graph: "Samanburður",
    certificates: "Vottanir",

    information_page: "Upplýsingasíða",
    laufid_guide: "Leiðin að Laufinu",

    cookie_consent:
        "Þessi vefsíða notar vafrakökur (e. Cookies) til að auka vafraupplifun þína",
    cookie_consent_button: "Ég skil",
    cookie_consent_link: "Sjá skilmála hér.",

    monday: "Mánudagur",
    tuesday: "Þriðjudagur",
    wednesday: "Miðvikudagur",
    thursday: "Fimmtudagur",
    friday: "Föstudagur",
    saturday: "Laugardagur",
    sunday: "Sunnudagur",

    searchPlaceholder: "",
    searchButton: "Leita",

    search_results: "Leitarniðurstöður",
    search_results_for: "Leitarniðurstöður fyrir",

    nothing_found_with: "Ekkert fannst með leitarorðinu",
    nothing_found_using: "notast við",

    individuals: "Einstaklingar",

    load_more_companies: "Sækja fleiri fyrirtæki",
    load_more_individuals: "Sækja fleiri einstaklinga",

    no_products_found_for: "Engar vörur fundust með leitarorðinu",
    no_results_for: "Engar niðurstöður fundust fyrir",

    not_finding_what_you_are_looking_for:
        "Finnur þú ekki það sem þú leitar að?",
    we_can_help: "Við getum aðstoðað þig í síma 1819",
    call_1819: "Hringja í 1819",
    have_a_suggestion: "Hefur þú ábendingu fyrir okkur?",
    here_you_can_send_us: "Hér getur þú sent okkur ábendingu",
    send_us_a_message: "Senda okkur ábendingu",
    you_know_where_to_look: "Er að leita...",

    search_result_list: "Listi",
    search_result_graph: "Samanburður",
    search_result_products: "Vörur",

    open: "Opið",
    closed: "Lokað",

    ad: "AUGLÝSING",

    sdg: "Heimsmarkmiðin",
    esg: "UFS",

    info_details_sustainability: "Sjálfbærni",
    info_details_carbon_neutrality: "Loftslagsáhrif",
    info_details_opening_hours: "Opnunartímar",
    info_details_phone_number_singular: "Símanúmer",
    info_details_phone_number_plural: "Símanúmer",
    info_details_website_singular: "Vefsíða",
    info_details_website_plural: "Vefsíður",
    info_details_email_singular: "Netfang",
    info_details_email_plural: "Netföng",
    info_details_kennitala: "Kennitala",
    info_details_fyrirtaekjaskra: "Fyrirtækjaskrá",
    info_details_social_media: "Samfélagsmiðlar",
    info_details_map: "Kort",
    info_details_tags: "Merkingar",
    info_details_brands: "Vörumerki",
    info_details_services: "Þjónustur",
    info_details_other_listings: "Aðrar skráningar",
    info_details_employees: "Starfsfólk",
    info_details_navigate: "Leiðarlýsing",
    info_details_more_info: "Nánari upplýsingar",
    info_details_kennitala_abbr: "Kt.",

    front_page: "Forsíða",

    map_search_on_map: "Leita á korti",

    opening_hours_open_until: "Opið til",
    opening_hours_open_until_midnight: "Opið til miðnættis",
    opening_hours_opens_at: "Opnar kl.",
    opening_hours_closed: "Lokað",
    opening_hours_always_open: "Alltaf opið",

    more_details_link: "Nánari upplýsingar",

    graph_companies: "Fyrirtæki",
    graph_gray_zone: "Gráa svæðið",
    graph_green_zone: "Græna svæðið",
    graph_leaves: "lauf",
    graph_pluses: "Græn skref",

    about_us_title: "Um okkur",
    about_us_section:
        "Hugmyndin um Laufið fæddist síðla árs 2020 og hefur vaxið og dafnað síðan. Við höfum lagt okkur fram við að skapa vöru og þjónustu ætlaða til að hafa samfélagsleg áhrif. Mikil vinna hefur verið lögð í að þróa vöruna með aðkomu fjölda fyrirtækja í rýnihópum, faglega aðstoð sérfræðinga í umhverfis- og sjálfbærnimálum svo ekki sé minnst á allt það hæfileikaríka starfsfólk sem hefur komið að þróuninni. Mikil áhersla er lögð á að hlustað sé á rödd framtíðar viðskiptavina og notenda sem og sérfræðinga við bestun á Laufinu.",

    our_history_title: "Sagan okkar",
    our_history_section:
        "Tvö rótgróin fyrirtæki, 1819 og Zenter ehf, eiga heiðurinn að Laufinu. 1819 var stofnað árið 2014 og er upplýsinga og þjónustufyrirtæki sem leitast við að aðstoða einstaklinga sem og fyrirtæki í upplýsingagjöf og auknum sýnileika. Zenter er hugbúnaðarfyrirtæki sem hefur frá árinu 2010 þróað og rekið hugbúnað fyrir fyrirtæki sem inniheldur m.a. tölvupósts-, SMS-, CRM- og sölutækifæriskerfi. Saman leggja þau grunninn að Laufinu.",

    services_companies_title: "Þjónusta við fyrirtæki og stjórnendur þeirra",
    services_companies_section1:
        "Laufið er stafrænn vettvangur þar sem stjórnendur íslenskra fyrirtækja geta sameinast og hagnýtt sér fjölbreytt verkfæri í vegferð að sjálfbærari fyrirtækjarekstri, samfélagslegri ábyrgð og í baráttunni við loftslagsvánna.",
    services_companies_section2:
        "Eftir samtal við stjórnendur lítilla og meðalstórra fyrirtækja á Íslandi var ljóst að fyrirtækjunum skortir hagnýt verkfæri til að stýra og taka þátt í aðgerðum sem stuðla að sjálfbærari fyrirtækjarekstri. Verkfærakista og hvatakerfi Laufsins leitast við að svara kalli stjórnenda fyrirtækja með því að leiða þau áfram í einföldum en mikilvægum aðgerðum sem draga úr umhverfisspori fyrirtækjanna og hjálpa til við að stuðla að ábyrgu samfélagi.",

    services_individuals_title: "Þjónusta við neytendur",
    services_individuals_section1:
        "Laufið er fyrsta græna íslenska upplýsingaveitan. Henni er ætlað að valdefla neytendur og gefa þeim kost á að taka upplýstar ákvarðanir um neyslu sína eftir því hversu vel fyrirtæki eru að standa sig í sjálfbærni og samfélagslegri ábyrgð.",
    services_individuals_section2:
        "Á laufid.is munu öll geta leitað að fyrirtækjum, vörum og þjónustu. Neytendur munu geta séð nákvæmlega hvað fyrirtæki eru að gera í umhverfis- og sjálfbærnimálum, gert samanburð á milli fyrirtækja, leitað að vottuðum vörum og tekið upplýstar ákvarðanir um hvaða vörur og þjónustu þau kjósa að versla og við hvaða fyrirtæki.",

    audlindatorg_title: "Auðlindatorg",
    audlindatorg_section:
        "Auðlindatorg er markaðstorg þar sem aðeins er verslað með notaða vöru. Auðlindatorgi er ætlað að einfalda fyrirtækjum að styðja við hugmyndir hringrásarhagkerfis og hvetja fyrirtæki til að hætta að hugsa einnota. Auðlindatorg verður bæði aðgengilegt á vefsíðu sem og í appi en þar verður hægt að selja, kaupa, leigja, lána eða gefa vörur á einfaldan hátt. Auðlindatorg verður aðgengilegt öllum.",

    umhverfismaelabord_title: "Umhverfismælaborð",
    umhverfismaelabord_section:
        "Umhverfismælaborðið er eitt af verkfærum Laufsins, og að hluta til okkar framlag til að ná markmiðum Parísarsáttmálans. Tilgangur mælaborðsins svarar einnig þeirri þörf að búa til, og halda utan um, stærstu gagnaveitu um stöðu umhverfis- og loftslagsmála á Íslandi. Aðaltilgangur umhverfismælaborðsins er að auðvelda ríkisstjórn, ráðherrum, stjórnum sveitarfélaga og öðrum lykil hagaðilum aðgang að gögnum sem sýna stöðu mála í rauntíma, þ.e.a.s. úrgangsmál, kolefnislosun og bindingu, loftslagsmál, orkumál, samgöngumál, stöðu byggingaiðnaðar og stöðu bifreiðar og annarra ökutækja.",
};
